import values from 'lodash/values';

import endpoints from '../../../../config/endpoints';

import { enum as utmTags } from '../../../../../../../enums/utm-tags';
import { enum as dashboardVisitActions } from '../../../../../../../enums/dashboard-visit-actions';

function createUtmTagFilter(name, title, placeholder) {
	return {
		name,
		title,
		placeholder,
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: true,
		options: {
			type: 'dynamic',
			source: endpoints.LOOKUPS.UTM_TAGS.replace('{tag}', name)
		}
	};
}

export const workingGeoFilter = {
	name: 'geos',
	title: 'Working GEOs',
	placeholder: 'Add working GEOs',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: false,
	options: {
		type: 'dynamic',
		source: endpoints.LOOKUPS.LOCATIONS
	}
};

export const utmTagFilters = [
	createUtmTagFilter(utmTags.utm_source, 'UTM: source', 'Add utm (source)'),
	createUtmTagFilter(utmTags.utm_medium, 'UTM: medium', 'Add utm (medium)'),
	createUtmTagFilter(utmTags.utm_campaign, 'UTM: campaign', 'Add utm (campaign)'),
	createUtmTagFilter(utmTags.utm_term, 'UTM: term', 'Add utm (term)'),
	createUtmTagFilter(utmTags.utm_content, 'UTM: content', 'Add utm (content)'),
	createUtmTagFilter(utmTags.data1, 'UTM: data1', 'Add utm (data1)'),
	createUtmTagFilter(utmTags.data2, 'UTM: data2', 'Add utm (data2)'),
	createUtmTagFilter(utmTags.data3, 'UTM: data3', 'Add utm (data3)'),
	createUtmTagFilter(utmTags.data4, 'UTM: data4', 'Add utm (data4)'),
	createUtmTagFilter(utmTags.data5, 'UTM: data5', 'Add utm (data5)')
];

export const dashboardReferersFilter = {
	name: 'dashboard_referer',
	title: 'Dashboard referers',
	placeholder: 'Add dashboard referers',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.LOOKUPS.DASHBOARD_REFERERS
	}
};

export const dashboardVisitActionFilter = {
	name: 'dashboard_visit_action',
	title: 'Dashboard visit action (UTM)',
	placeholder: 'Add visit action',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'provided',
		source: values(dashboardVisitActions).map(action => ({
			value: action,
			label: action
		}))
	}
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/filters/list/index.js